import { Box, Text, Layer, InfiniteScroll } from "grommet";
import TocUnit from "./TocUnit";

const TocList = (props:any) => {
    const tocInfo = props.tocinfo;
    const bookInfo = props.bookinfo;
    // console.log("TocList bookInfo", bookInfo, props.bookinfo)
    return (
      <Box
        align="center"
        justify="start"
        width="full"
        height="full"
      >
        <Box
          width="full"
          border={{ color: "white", size: "0.5px" }}
          margin={{ top: "20px" }}
          pad="5px"
          background="rgb(255,255,255,0.5)"
        >
          <Box
            align="center"
            justify="start"
            margin={{ top: "20px", bottom: "20px", left: "10px" }}
          >
            <Text size="15px" weight="bold">
              목차
            </Text>
          </Box>
          {tocInfo.length !== 0 && <>
          <Box width='full' overflow='auto' pad={{horizontal:'5px'}}
            justify='start'>
            <InfiniteScroll items={tocInfo}>
                {(item: any) => (
                    <Box flex={false} key={item.toc_id} margin={{vertical:'5px'}}>
                        <TocUnit
                            key={item.toc_id}
                            tocid={item.toc_id}
                            title={item.toc_title}
                            titleko={item.toc_title_ko}
                            h={item.toc_hierarchy}
                            ntable={item.tableau_count}
                            nrecord={item.tocrecord_count}
                            bookinfo={bookInfo}
                        />
                    </Box>
                )}
            </InfiniteScroll>
          </Box></>}
        </Box>
      </Box>
    );
}
export default TocList;